import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {deleteItem, getItem, saveItem} from "../services/api";

export function EditItem() {
    const { itemId } = useParams()
    const [item, setItem] = useState({})
    const navigate = useNavigate()
    
    useEffect(() => {
        if (itemId !== "new") {
            getItem(itemId)
                .then(apiItem => {
                    setItem(apiItem);
                })
                .catch(ex => {
                    console.log("Error getting item: ", ex)
                })
        }
    }, [])
    
    const updateName = (event) => {
        setItem({
            ...item,
            name: event.target.value
        })
    }
    
    const updatePurchaseDate = (event) => {
        setItem({
            ...item,
            purchaseDate: event.target.value
        })
    }
    
    const updateLifespan = (event) => {
        setItem({
            ...item,
            lifespan: event.target.value
        })
    }
    
    const updateMaxLifespan = (event) => {
        setItem({
            ...item,
            maxLifespan: event.target.value
        })
    }
    
    const updatePenalty = (event) => {
        setItem({
            ...item,
            penalty: parseInt(event.target.value)
        })
    }

    const updatePriority = (event) => {
        setItem({
            ...item,
            priority: parseInt(event.target.value)
        })
    }
    
    const submit = async (event) => {
        event.preventDefault()
        
        try {
            await saveItem(item);
            navigate("/items")
        } catch(ex) {
            console.log("Error saving Item: ", ex)
        }
        
        
    }
    
    const handleDeleteItem = async(event) => {
        try {
            await deleteItem(itemId)
            navigate("/items")
        }
        catch(ex) {
            console.log("Error deleting Item: ", ex)
        }
    }
    
    return (
        <form onSubmit={submit}>
            <div className="form-group mb-3">
                <label>Name</label>
                <input type="text" className="form-control" value={item.name} onChange={updateName}/>
            </div>
            <div className="form-group mb-3">
                <label>Purchase Date</label>
                <input className="form-control" type="text" value={item.purchaseDate} onChange={updatePurchaseDate}/>
            </div>

            <div className="form-group mb-3">
                <label>Min Lifespan</label>
                <input className="form-control" type="text" value={item.lifespan} onChange={updateLifespan}/>
            </div>
            <div className="form-group mb-3">
                <label>Max Lifespan</label>
                <input className="form-control" type="text" value={item.maxLifespan} onChange={updateMaxLifespan}/>
            </div>
            <div className="form-group mb-3">
                <label>Penalty</label>
                <input className="form-control" type="text" value={item.penalty} onChange={updatePenalty}/>
            </div>
            <div className="form-group mb-3">
                <label>Priority</label>
                <select className="form-control" value={item.priority} onChange={updatePriority}>
                    <option value="">Select Priority</option>
                    <option value="1">Critical</option>
                    <option value="2">High</option>
                    <option value="3">Medium</option>
                    <option value="4">Low</option>
                </select>
            </div>
            <div className="form-group">
                <button className="btn btn-primary">Submit</button>
                { (itemId > 0) && <button className="ms-1 btn btn-danger" onClick={handleDeleteItem}>Delete</button> }
            </div>
        </form>
    )
}